/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DialerScheduleSettingsCreate } from '../models/DialerScheduleSettingsCreate';
import type { DialerScheduleSettingsResponse } from '../models/DialerScheduleSettingsResponse';
import type { DialerScheduleSettingsUpdate } from '../models/DialerScheduleSettingsUpdate';
import type { DialerScheduleTemplate } from '../models/DialerScheduleTemplate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DialerScheduleSettingsService {
    /**
     * List Dialer Schedule Versions
     * @param campaignId
     * @returns DialerScheduleSettingsResponse Successful Response
     * @throws ApiError
     */
    public static listDialerScheduleVersionsApiCampaignsCampaignIdDialerScheduleSettingsGet(
        campaignId: string,
    ): CancelablePromise<Array<DialerScheduleSettingsResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/campaigns/{campaign_id}/dialer-schedule-settings',
            path: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Dialer Schedule Version
     * @param campaignId
     * @param requestBody
     * @returns DialerScheduleSettingsResponse Successful Response
     * @throws ApiError
     */
    public static createDialerScheduleVersionApiCampaignsCampaignIdDialerScheduleSettingsPost(
        campaignId: string,
        requestBody: DialerScheduleSettingsCreate,
    ): CancelablePromise<DialerScheduleSettingsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/campaigns/{campaign_id}/dialer-schedule-settings',
            path: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Active Dialer Schedule
     * Edit the active version's config in place (no new version). Use POST to
     * snapshot a new version instead.
     * @param campaignId
     * @param requestBody
     * @returns DialerScheduleSettingsResponse Successful Response
     * @throws ApiError
     */
    public static updateActiveDialerScheduleApiCampaignsCampaignIdDialerScheduleSettingsPut(
        campaignId: string,
        requestBody: DialerScheduleSettingsUpdate,
    ): CancelablePromise<DialerScheduleSettingsResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/campaigns/{campaign_id}/dialer-schedule-settings',
            path: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Active Dialer Schedule
     * @param campaignId
     * @returns DialerScheduleSettingsResponse Successful Response
     * @throws ApiError
     */
    public static getActiveDialerScheduleApiCampaignsCampaignIdDialerScheduleSettingsActiveGet(
        campaignId: string,
    ): CancelablePromise<DialerScheduleSettingsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/campaigns/{campaign_id}/dialer-schedule-settings/active',
            path: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Dialer Schedule Templates
     * Built-in preset schedules the UI copies into a new version.
     * @param campaignId
     * @returns DialerScheduleTemplate Successful Response
     * @throws ApiError
     */
    public static listDialerScheduleTemplatesApiCampaignsCampaignIdDialerScheduleSettingsTemplatesGet(
        campaignId: string,
    ): CancelablePromise<Array<DialerScheduleTemplate>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/campaigns/{campaign_id}/dialer-schedule-settings/templates',
            path: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Activate Dialer Schedule Version
     * @param campaignId
     * @param version
     * @returns DialerScheduleSettingsResponse Successful Response
     * @throws ApiError
     */
    public static activateDialerScheduleVersionApiCampaignsCampaignIdDialerScheduleSettingsVersionActivatePost(
        campaignId: string,
        version: number,
    ): CancelablePromise<DialerScheduleSettingsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/campaigns/{campaign_id}/dialer-schedule-settings/{version}/activate',
            path: {
                'campaign_id': campaignId,
                'version': version,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
